var elem = document.querySelector('.sec-2');
var flkty = new Flickity(elem, {
  cellAlign: 'left',
  contain: true,
  pageDots: false,
  autoPlay: 5000,
  wrapAround: true,
  adaptiveHeight: true,
  dragThreshold: window.innerWidth < 768? 50: 0
});

document.querySelectorAll('.btn-1').forEach(btn=>{
    btn.addEventListener('click',e=>{
      document.getElementById('shopify-section-template--17466157400215__case_studies_wtXUdV').scrollIntoView({behavior: 'smooth'})
    })
  })
const case_study_slider = new Flickity( document.querySelector('.case-studies-slider__slider'), {
  cellAlign: 'left',
  contain: true,
  pageDots: false,
  adaptiveHeight: true,
  dragThreshold: window.innerWidth < 768? 50: 0
});
setTimeout(()=>{
  window.dispatchEvent(new Event('resize'));
},1000)
  

document.querySelectorAll('[data-slider]').forEach(btn=>{
  btn.addEventListener('click',e=>{
    console.log(parseInt(case_study_slider.element.querySelector(`#${btn.dataset.slider}`)?.dataset.index))
    case_study_slider.select(parseInt(case_study_slider.element.querySelector(`#${btn.dataset.slider}`)?.dataset.index),false, true)
    document.querySelector('.case-studies-slider').classList.add('shown');
    document.querySelector('html').style.overflow = 'hidden';
    document.querySelector('.grfq-quote-widget-container').classList.add('slider-active');
    window.dispatchEvent(new Event('resize'));

  })
})

document.querySelector('[data-close-case-studies]').addEventListener('click',e=>{
  document.querySelector('.case-studies-slider').classList.remove('shown');
  document.querySelector('html').style.overflow = null;
    document.querySelector('.grfq-quote-widget-container').classList.remove('slider-active');
})

window.addEventListener('resize',e=>{
  document.querySelectorAll('.case-studies-slider__slide,.case-studies-slider__slide-inner').forEach(el=>{el.style.height=window.innerHeight+'px'})
})
document.querySelectorAll('.case-studies-slider__slide,.case-studies-slider__slide-inner').forEach(el=>{el.style.height=window.innerHeight+'px'});
window.dispatchEvent(new Event('resize'));
